@import (reference) "../../references.less";

.root {
}

.wrapper {
  position: relative;
}

.card {
  position: relative;
  @ratio: 0.75;
  @width: 250;
  background: @color-grey-1;
  .R(width, @width);
  .R(height, @width / @ratio);
}

.pic {
  @ratio: 0.82;
  @width: 200;
  .absoluteCenter(x);
  .R(top, 28);
  background: @color-grey-2;
  .R(width, @width);
  .R(height, @width / @ratio);
}

.deco {
  .R(width, 40);
  height: 2px;
  background-color: @color-grey-2;
  position: absolute;
  .R(bottom, 50);
  .R(right, 25);
}
